import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppStore } from '@aaa/emember/store-types';
import { getExecutionError, getJoinFormConfirmedMembers } from '@aaa/emember/store-join';
import { map } from 'rxjs/operators';
import { of, switchMap, tap, withLatestFrom } from 'rxjs';
import { Pages } from '../../../constants/pages';

export const checkConfirmationData: CanActivateChildFn = () => {
  const router = inject(Router);
  const store = inject(Store<AppStore>);

  return store.select(getJoinFormConfirmedMembers).pipe(
    switchMap((members) => of(members).pipe(withLatestFrom(store.select(getExecutionError)))),
    map(([members, error]) => !!members.length || !!error),
    tap((confirmation) => !confirmation && router.navigateByUrl(Pages.offers)),
  );
};

export default checkConfirmationData;
